import React from 'react';
import { Link } from 'react-router-dom';
import { LoginHeader } from '../Common/LoginHeader';
import { Footer, Header } from '../Common';
import { connect } from 'react-redux';
import { sellerLogin } from '../../Action/login';
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';

// import { GoogleLoginItem } from './GoogleLoginItem';
import { FacebookLoginItem } from './FacebookLoginItem';
import {FacebookFirebaseLogin, GoogleFirebaseLogin} from "../components";
import {withTranslation} from "react-i18next";
import { Translation } from 'react-i18next';
class SellerLogin extends React.Component {
    constructor(props) {
        super(props);
        // if (!JSON.parse(window.localStorage.getItem('info')).email){
        //     this.props.history.push('/seller-login')
        // }
        this.state = {
            _id: false,
            email: '',
            password: '',
            user_type: 2,
            errors: [],
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('VERIFY_MSG.INTEGER')}`,
            max: `:attribute :max ${this.props.t('VERIFY_MSG.MAX')}`,
            required: ` :attribute ${this.props.t('VERIFY_MSG.REQUIRED')}`,
            min: `:attribute :min ${this.props.t('VERIFY_MSG.MIN')}`,
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        window.localStorage.removeItem('info');
        window.localStorage.removeItem('pro_pic');
        localStorage.clear();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            if (nextProps.errors.errors === 'WRONG_CRED') {
                nextProps.errors.errors = this.props.t('LOGIN.WRONG_CRED');
                console.log("eeeeeeeeeee iiiiii: ", nextProps.errors.errors.errors);
            }
            this.setState({ errors: nextProps.errors });
        }
    }

    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            let data = {
                email: this.state.email,
                password: this.state.password,
            }
            // console.log(data);

            // sellerLogin(data, this.props.history, this.dispatch);
            this.props.sellerLogin(data, this.props.history);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        const { errors } = this.state.errors;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                        <div className="row ">
                            <div className="col-md-2">

                            </div>
                            <div className="col-md-4 ">
                                <div className="big_text" style={{ paddingBottom: '0px' }}><b>{this.props.t('LOGIN.LOGIN_TITLE_SELLER') }</b></div>
                                <div className="login_inputs form-group " style={{ padding: '20px' }}>
                                    <form onSubmit={this.handleSubmit.bind(this)}>
                                        <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                        <div>
                                            <div className="name_text"><b>{this.props.t('LOGIN.MAIL_ADDRESS') }</b>
                                            </div>
                                        </div>
                                        <div>
                                            <div>

                                                <input type="email" className="user_id_box form-control" placeholder={this.props.t('LOGIN.MAIL_ADDRESS_PLACE') } id="email" value={this.state.email} onChange={this.updateField.bind(this, "email")} />
                                                <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('GLOBAL.MAIL_ADDRESS'), this.state.email, 'required')}</span>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="name_text"><b>{this.props.t('LOGIN.PASSWORD') }</b>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <input type="password" className="user_id_box form-control" placeholder={this.props.t('LOGIN.PASSWORD_PLACE') } id="password1" value={this.state.password} onChange={this.updateField.bind(this, "password")} />
                                                <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('GLOBAL.PASSWORD'), this.state.password, 'required|min:8')}</span>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="remember_text"><input type="checkbox" />&nbsp;&nbsp;{this.props.t('LOGIN.SAVE_LOGIN_INFO')}</div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="input_name">
                                                <button type="submit" className="btn  btn-lg button_size" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('LOGIN.LOGIN_BUTTON')}</button>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div><div className="input_name remember_text">{this.props.t('LOGIN.FORGOT_PASSWORD')}<Link className="blue_text" to={"/password-reset"}>{this.props.t('LOGIN.ONCLICK_ACTION')}</Link> </div></div>
                                        <div><div className="input_name remember_text">{this.props.t('LOGIN.NON_REGISTERED')}<Link className="blue_text" to={"/seller-registration-step-1"}>{this.props.t('LOGIN.ONCLICK_ACTION')}</Link> </div></div>
                                        <br />
                                        <div><div className="input_name remember_text">{this.props.t('LOGIN.BUYER_LOGIN')}<Link className="blue_text" to={"/login"}>{this.props.t('LOGIN.ONCLICK_ACTION')}</Link> </div></div>
                                    </form>
                                </div>
                            </div>

                            <div className="col-md-4 ">
                                <div className="big_text">&nbsp;</div>
                                <div className="login_inputs form-group" style={{ height: "300px" }}>
                                    <div className="tr_blank"><div>&nbsp;</div></div>
                                    {/*<GoogleLoginItem id={this.state.user_type} />*/}
                                    <GoogleFirebaseLogin id={this.state.user_type} />
                                    <br />
                                    <br />
                                    {/*<FacebookLoginItem id={this.state.user_type} />*/}
                                    <FacebookFirebaseLogin id={this.state.user_type} />
                                    <br />
                                    <br />
                                    <img alt="" src={require("../../assets/images/Logo-LINE.png")} height="50px" width='100%' />
                                </div>
                            </div>
                            <div className="col-md-2">
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div >
            );
        }
        else if (isDesktop) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12" >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                            {/* <div className="col-md-12"> */}
                            <div className="row mt-5">
                                <div className="col-md-2">

                                </div>
                                <div className="col-md-4 mt-5">
                                    <div className="big_text"><b>{this.props.t('LOGIN.LOGIN_TITLE_SELLER') }</b></div>
                                    <div className="login_inputs form-group pl-5">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                            <div>
                                                <div className="name_text"><b>{this.props.t('LOGIN.MAIL_ADDRESS') }</b>
                                                </div>
                                            </div>
                                            <div>
                                                <div>

                                                    <input type="email" className="user_id_box form-control" placeholder={this.props.t('LOGIN.MAIL_ADDRESS_PLACE') } id="email" value={this.state.email} onChange={this.updateField.bind(this, "email")} />
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('GLOBAL.MAIL_ADDRESS'), this.state.email, 'required')}</span>
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="name_text"><b>{this.props.t('LOGIN.PASSWORD') }</b>
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <input type="password" className="user_id_box form-control" placeholder={this.props.t('LOGIN.PASSWORD_PLACE') } id="password1" value={this.state.password} onChange={this.updateField.bind(this, "password")} />
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('GLOBAL.PASSWORD'), this.state.password, 'required|min:8')}</span>
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="remember_text"><input type="checkbox" />&nbsp;&nbsp;{this.props.t('LOGIN.SAVE_LOGIN_INFO')}</div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="input_name">
                                                    <button type="submit" className="btn  btn-lg button_size" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('LOGIN.LOGIN_BUTTON')}</button>
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div><div className="input_name remember_text">{this.props.t('LOGIN.FORGOT_PASSWORD')}<Link className="blue_text" to={"/password-reset"}>{this.props.t('LOGIN.ONCLICK_ACTION')}</Link> </div></div>
                                            <div><div className="input_name remember_text">{this.props.t('LOGIN.NON_REGISTERED')}<Link className="blue_text" to={"/seller-registration-step-1"}>{this.props.t('LOGIN.ONCLICK_ACTION')}</Link> </div></div>
                                            <br />
                                            <div><div className="input_name remember_text">{this.props.t('LOGIN.BUYER_LOGIN')}<Link className="blue_text" to={"/login"}>{this.props.t('LOGIN.ONCLICK_ACTION')}</Link> </div></div>
                                        </form>
                                    </div>
                                </div>

                                <div className="col-md-4 mt-5">
                                    <div className="big_text">&nbsp;</div>
                                    <div className="login_inputs form-group">
                                        <div className="tr_blank" style={{height:'25px'}}>
                                            {/* <div>&nbsp;</div> */}
                                        </div>
                                        {/* <div className="tr_blank"><div>&nbsp;</div></div> */}
                                        <div className="tr_blank">
                                            {/* <div>&nbsp;</div> */}
                                        </div>
                                        {/*<GoogleLoginItem id={this.state.user_type} />*/}
                                        <GoogleFirebaseLogin id={this.state.user_type}  />
                                        <br />
                                        <br />
                                        {/*<FacebookLoginItem id={this.state.user_type} />*/}
                                        <FacebookFirebaseLogin id={this.state.user_type} />
                                        <br />
                                        <br />
                                        <img alt="" src={require("../../assets/images/Logo-LINE.png")} height="50px" width='100%' />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div >
            );
        }
    }
}

const mapStateToProps = (state) => ({
    sellerLogin: state.sellerLogin,
    errors: state.errors,
});

SellerLogin = connect(mapStateToProps, { sellerLogin })(withRouter(SellerLogin));
// export { SellerLogin };
// SellerLogin = withTranslation("seller")(SellerLogin);

export default withTranslation('seller')(SellerLogin);
